import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs/internal/Observable";
import { shareReplay } from "rxjs/operators";

import { ToastService } from "@dffedb/ui";

import { StamoplysningerViewModel } from "./model/stamoplysninger.view-model";
import { StamoplysningerSandbox } from "./stamoplysninger.sandbox";

@Component({
    selector: "e-forsyning-stamoplysninger",
    templateUrl: "./stamoplysninger.component.html"
})
export class StamoplysningerComponent implements OnInit {
    public vm$: Observable<StamoplysningerViewModel>;

    constructor(private readonly sandbox: StamoplysningerSandbox, private readonly toastService: ToastService) {}

    public ngOnInit(): void {
        this.vm$ = this.sandbox.hentViewModel().pipe(shareReplay(1));
    }

    public async redigerTelefonnr(formGroup: UntypedFormGroup, nytTelefonnr: string): Promise<void> {
        if (formGroup.controls.telefonnr.invalid) {
            return;
        }

        try {
            await this.sandbox.redigerTelefonnr(nytTelefonnr);
            formGroup.controls["telefonnr"].disable();
        } catch (e) {
            this.toastService.visFejl(e.friendlyMessage);
        }
    }

    public annullerRedigerTelefonnr(formGroup: UntypedFormGroup, telefonnr: string): void {
        formGroup.controls["telefonnr"].setValue(telefonnr);
        formGroup.controls["telefonnr"].disable();
    }

    public async redigerBeboeremail(formGroup: UntypedFormGroup, nyBeboeremail: string): Promise<void> {
        if (formGroup.controls.beboeremail.invalid) {
            return;
        }
        try {
            await this.sandbox.redigerBeboeremail(nyBeboeremail);
            formGroup.controls["beboeremail"].disable();
        } catch (e) {
            this.toastService.visFejl(e.friendlyMessage);
        }
    }

    public annullerRedigerBeboeremail(formGroup: UntypedFormGroup, beboeremail: string): void {
        formGroup.controls["beboeremail"].setValue(beboeremail);
        formGroup.controls["beboeremail"].disable();
    }

    public addFocus(id: string): void {
        if (document.getElementById(id) === null) return;
        document.getElementById(id).focus();
    }
}
